module.exports = __webpack_public_path__ + "img/y- (13).5e6176b3.jpg";